import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { routes } from '../pages';

export const ApplyRouter = () => {
  const router = createBrowserRouter(routes);

  return <RouterProvider router={router} />;
};
